import { memo } from "react"
import { useNeoButtonPopupContext } from "@neo/neo-common-ui/lib/components/neo-popover/NeoButtonPopup"
import { FormattedMessage } from "react-intl"
import { MoreCell } from "../InlineDrawer/StyleComponents"

/**
 * Rendered only as the button of PopupComponent's NeoButtonPopup, which already
 * sits under the error boundary, theme and intl providers. Do not re-wrap here.
 */
const TableColumnMoreBtn = ({ amount }: { amount: number }) => {
  const ctx = useNeoButtonPopupContext()
  return (
    <MoreCell id="popover_more_btn" $isActive={ctx.isOpen}>
      <FormattedMessage
        id="event_details_list_more"
        defaultMessage="+ {amount} more"
        values={{ amount: amount }}
      />
    </MoreCell>
  )
}

export default memo(TableColumnMoreBtn)
